<app-searchable-filter-dropdown
  [formControl]="formControl"
  [label]="'global.filter.trailers'"
  [multiple]="false"
  [options]="(trailersData$ | async) ?? []"
></app-searchable-filter-dropdown>